<script lang="ts" setup>
const props = defineProps<{
  label: string
}>()
</script>

<template>
  <div class="inline-flex w-full flex-wrap">
    <span class="inline-block w-[30%]">{{ props.label }}</span>
    <span class="inline-block w-[70%] pl-2.5">
      <slot />
    </span>
  </div>
</template>
